import { gql } from '@apollo/client';
export default gql`
  query getDocEntrys($start: Date, $end: Date) {
    getDocEntrys(start: $start, end: $end) {
      ok
      error
      count
      data {
        _id
        branch
        opType
        opId
        opNo
        time
        title
        desc
        stepId
        stepTime
        stepName
        stepNameAr
        stepDesc
        stepUser
        stepUserName
        stepColor
        steps

        contractId
        contractName
        contractNameAr

        customerId
        customerName
        customerNameAr

        supplierId
        supplierName
        supplierNameAr

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr
        employeeColor

        resourseId
        resourseName
        resourseNameAr
        resourseColor

        amount
        debit
        debitAcc
        debitAccName
        debitAccNameAr
        credit
        creditAcc
        creditAccName
        creditAccNameAr
        attachments

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
